import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrMC: CultureInfo = {
  name: 'fr-MC',
  displayName: 'French (Monaco)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-MC',
  parent: CultureInfoFr
};
